/**
 * Wrap of localStorage to store data with expiry
 */
export default {
	/**
	 * Sets data to localStorage with expire time (ttl)
	 * @param {string} key
	 * @param {*} value
	 * @param {number} ttl Time to live in milliseconds
	 */
	setWithExpiry(key, value, ttl) {
		const now = new Date()

		const item = {
			value: value,
			expiry: now.getTime() + ttl,
		}

		localStorage.setItem(key, JSON.stringify(item))
	},

	/**
	 * Gets data from local storage, which was set by setWithExpiry().
	 * @param {string} key
	 * @return {null|*}
	 */
	getWithExpiry(key) {
		const itemStr = localStorage.getItem(key)
		// if the item doesn't exist, return null
		if (!itemStr) {
			return null
		}

		const item = JSON.parse(itemStr)
		const now = new Date()

		// compare the expiry time of the item with the current time
		if (now.getTime() > item.expiry) {
			// If the item is expired, delete the item from storage
			// and return null
			localStorage.removeItem(key)

			return null
		}

		return item.value
	},
}